import { useState } from 'react'
import cn from 'classnames'
import i18nInstance from 'i18n/i18nInstance'
import { Radio } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { ButtonsSection } from '../../components/ButtonsSection/ButtonsSection'
import { InteractiveStep } from '../../components/InteractiveStep'
import { useQuizEvents } from '../../events'
import { type LearningOptionType } from '../../types'
import classes from './LearningTime.module.scss'

const tf = i18nInstance.getFixedT(null, '@mc/next')

const LEARNING_TIME_OPTIONS = (
  tf('findMyClasses.steps.learningTime.options', {
    returnObjects: true,
  }) as LearningOptionType[] | undefined
)?.map((value, index) => ({
  id: index + 1,
  value,
}))

export const LearningTime = () => {
  const { t } = useTranslation('@mc/next')
  const { trackOptionSelected, trackAnswerSubmitted } = useQuizEvents()
  const [selectedOption, setSelectedOption] = useState<
    LearningOptionType | undefined
  >()

  const handleOptionSelected = (value: LearningOptionType) => {
    trackOptionSelected({
      value,
      checked: true,
    })
    setSelectedOption(value)
  }

  const onClickNext = () => {
    if (selectedOption) {
      trackAnswerSubmitted({
        selectedOptions: [selectedOption],
      })
    }
  }

  return (
    <InteractiveStep title={t('findMyClasses.steps.learningTime.title')}>
      <div className='mc-my-7'>
        <div className='row no-gutters-vertical justify-content-center'>
          <div className='col-12 col-md-10 col-lg-7'>
            <div className='mc-my-2'>
              {LEARNING_TIME_OPTIONS?.map(({ id, value }, index) => {
                const isFirst = index === 0
                const isLast = index === LEARNING_TIME_OPTIONS.length - 1
                const isSelected = value === selectedOption
                return (
                  <Radio
                    key={id}
                    className={cn('mc-bg-gray-100 mc-p-6', classes.radio, {
                      'mc-bg-gray-300': isSelected,
                      'mc-corners-top-left--sm mc-corners-top-right--sm':
                        isFirst,
                      'mc-corners-bottom-left--sm mc-corners-bottom-right--sm':
                        isLast,
                    })}
                    onChange={() => handleOptionSelected(value)}
                    checked={isSelected}
                    option={value}
                    name={value}
                    label={value}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <ButtonsSection
        disabled={!selectedOption}
        onNext={onClickNext}
        machineEvent={{
          machineEventType: 'time_spent' as const,
          timeSpent: selectedOption,
        }}
        disabledText={t(
          'findMyClasses.steps.motivation.a11y.disabledDisclaimer',
        )}
      />
    </InteractiveStep>
  )
}
